import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (props: templates.RedirectPageTemplate) => (
    <React.StrictMode>
        <PageSkeleton {...props.page}></PageSkeleton>
    </React.StrictMode>
);
